import { makeStyles, Theme, Grid } from "@material-ui/core";
import { ConfirmationButton, createDateField, createPercentageField, createRadioField, createTextField, CurrencyField, DateField, trueFalseOptions } from "@roc/ui";
import { observer } from "mobx-react";
import PayoffRequestDetailStore from "../../stores/payoffRequestDetailStore";

const useStyles = makeStyles((theme: Theme) => ({
  formFields: {
    marginTop: '1rem',
  },
  recalculate: {
    marginTop: '2rem',
  },
  radioField: {
    paddingLeft: '10px',
  },
}));

interface Props {
  store: PayoffRequestDetailStore;
  isEditMode: boolean;
}

export const PayoffRequestDetails = observer(({ store, isEditMode }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container direction="row" justify="space-around">
        <Grid item xs={7} className={classes.formFields}>
          {createDateField({
            store,
            testId: 'goodThroughDate',
            label: 'Good Through Date',
            fieldName: 'goodThroughDate',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createDateField({
            store,
            testId: 'requestedDate',
            label: 'Requested Date',
            fieldName: 'requestedDate',
            disabled: true,
          })}
        </Grid>
        <Grid container xs={7}>
          <Grid item xs={6} className={classes.formFields}>
            {createRadioField({
              store,
              testId: 'rush',
              fieldName: 'rush',
              label: 'Rush?',
              options: trueFalseOptions,
              row: true,
              tooltip: 'Extra fees will apply',
            })}
          </Grid>
          <Grid item xs={6} className={classes.formFields}>
            {createRadioField({
              store,
              testId: 'cema',
              fieldName: 'cema',
              label: 'CEMA?',
              options: trueFalseOptions,
              row: true,
            })}
          </Grid>
          {isEditMode && (
            <Grid item xs={6} className={classes.formFields}>
              {createRadioField({
                store,
                testId: 'foreclosure',
                fieldName: 'foreclosure',
                label: 'REO?',
                options: trueFalseOptions,
                row: true,
              })}
            </Grid>
          )}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Requester Email',
            fieldName: 'requesterEmail',
            testId: 'requesterEmail',
            type: 'email',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createPercentageField({
            store,
            testId: 'defaultRate',
            fieldName: 'defaultRate',
            label: 'Default Rate',
          })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createTextField({
            store,
            label: 'Comments',
            fieldName: 'comments',
            testId: 'comments',
            multiline: true,
            minRows: 2,
          })}
        </Grid>
      </Grid>
    </div>
  );
});
